import { render, staticRenderFns } from "./BaseAmount.vue?vue&type=template&id=3c5b1a02&scoped=true&"
import script from "./BaseAmount.vue?vue&type=script&lang=ts&"
export * from "./BaseAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b1a02",
  null
  
)

export default component.exports